import { Skeleton } from '@mui/material';
import { FC } from 'react';

const ProductDetailsFormSkeleton: FC = () => {
  return (
    <>
      <section>
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </section>
      <Skeleton animation="wave" variant="rectangular" height={128} />
    </>
  );
};

export default ProductDetailsFormSkeleton;
